<template>
  <div class="pwd_container">
    <div class="title">
      密码登录
    </div>
    <van-form @submit="onSubmit">
      <van-field
        v-model="pwdForm.username"
        placeholder="请输入手机号/用户名"
        class="field_item"
      />

      <van-field
        v-model="pwdForm.password"
        type="password"
        placeholder="请输入密码"
        class="field_item"
      />

      <div class="pwd_btn">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          color="#F93244"
          :disabled="!pwdForm.username || !pwdForm.password"
        >
          立即登录
        </van-button>
      </div>
    </van-form>
    <div class="action_btn">
      <span class="red" @click="openLink('/register')">立即注册 </span> |
      <span @click="openLink('/rePwd')">忘记密码</span>
    </div>
  </div>
</template>

<script>
import { sipLogin } from '@/api';
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';

export default {
  data() {
    return {
      pwdForm: {
        username: '',
        password: ''
      }
    };
  },
  methods: {
    onSubmit() {
      const { pwdForm } = this;
      if (!pwdForm.username.trim() || !pwdForm.password.trim()) {
        return this.$toast.fail('请输入完整的内容');
      }
      sipLogin(pwdForm).then((res) => {
        if (res.success) {
          const data = res.data;
          Vue.ls.set(ACCESS_TOKEN, data.token, 7 * 24 * 60 * 60 * 1000);
          this.$toast.success('登录成功');

          // 延迟 0.5 秒显示欢迎信息
          setTimeout(() => {
            this.pwdForm = '';
            if (this.$route.query.redirect) {
              let redirect = decodeURIComponent(this.$route.query.redirect);
              this.$router.push({ path: redirect });
            } else {
              this.$router.push({ path: '/' });
            }
          }, 500);
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    openLink(path) {
      if (path == '/register' && Vue.ls.get('inviterCode')) {
        this.$router.push({
          path,
          query: {
            c: Vue.ls.get('inviterCode')
          }
        });
      } else {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.pwd_container {
  padding: 19.733vw 0;
  .red {
    color: #f93244;
  }
  .title {
    padding-left: 4.267vw;
    font-size: 7.467vw;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 8.533vw;
  }
  .field_item {
    height: 14.933vw;
    margin-bottom: 4.267vw;
    display: flex;
    align-items: center;
    font-size: 4.533vw;
    color: rgba(0, 0, 0, 0.25);
  }
  .pwd_btn {
    padding: 24.533vw 4.267vw 5.333vw;
  }
  .action_btn {
    text-align: center;
    color: rgba(0, 0, 0, 0.25);
    font-size: 3.733vw;
  }
}
/deep/ .van-field__control {
  font-size: 4.533vw;
}
</style>
